import styled from "styled-components";

export const PageList = styled.ul`
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
`;

/* One row: a page card, spaced like the editor's section list */
export const PageItem = styled.li`
  position: relative;
  padding-top: 0.5rem;

  /* Each card is its own stacking layer (it can be dragged): the row whose "⋯" menu is open goes on top
     of the rows below, or they'd cover the menu */
  &:has([role="menu"]) {
    z-index: 30;
  }

  &:first-child {
    padding-top: 0;
  }

  .chevron {
    display: flex;
    color: var(--color-neutral-150);
  }
`;

/* "Principal" by the home's name: the PLUS tag's shape, in the neutral colors */
export const HomeTag = styled.span`
  flex-shrink: 0;
  padding: 0.125rem 0.5rem;
  font-family: Inter, sans-serif;
  font-size: 0.5625rem;
  font-weight: 800;
  line-height: 0.75rem;
  color: var(--color-neutral-white);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 100px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.22);
`;

/* The navigation menu's switch, after the list: a plain row with a line above it, no card */
export const MenuRow = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  /* the same room above the text (padding) as below it: the Section already puts 0.75rem between its children,
     so 0.5rem more makes the 1.25rem under the row before */
  margin-top: 0.5rem;
  padding-top: 1.25rem;
  font-family: Inter, sans-serif;
  border-top: 1px solid var(--color-neutral-dark);

  h6 {
    font-size: 0.875rem;
    font-weight: 700;
    color: var(--color-neutral-white);
  }

  .description {
    margin-top: 0.25rem;
    font-size: 0.75rem;
    color: var(--color-neutral-150);
  }

  .text {
    min-width: 0;
  }

  /* The switch's label is sized by its absolutely positioned track: given the track's box (and none of the margin
     meant for stacked forms), it centers on the text beside it, as in the Settings rows */
  > label {
    flex-shrink: 0;
    width: 40px;
    height: 24px;
    padding: 0;
    margin: 0;
  }
`;

export const Error = styled.p`
  margin-top: 4px;
  font-size: 0.75rem;
  color: var(--color-feedback-danger);
`;

/* With 10 pages, in place of the add card at the end of the list */
export const LimitNotice = styled.p`
  padding: 0.75rem 0 0;
  font-family: Inter, sans-serif;
  font-size: 0.875rem;
  color: var(--color-neutral-150);
`;

/* The bar's "+ Página", as the editor's "+ Seção" */
export const BarAdd = styled.button`
  display: flex;
  align-items: center;

  > h6 {
    margin-left: 12px;
  }

  &:disabled {
    cursor: default;
    opacity: 0.4;
  }
`;

/* Room for the fixed bar under the list */
export const BarSpace = styled.div`
  height: 6rem;
`;
